import React from "react";
import TransactionListASAP from "./TransactionListASAP"

export default class Order extends React.Component {

    async componentDidMount() {
        document.body.style.backgroundColor = "#e6e6fa";

        localStorage.setItem('TransactionType', JSON.stringify(0));
    }

    render() {
        return (
            <div>
                <TransactionListASAP type={0} history={this.props.history} delivery={false}></TransactionListASAP>
            </div>
        );
    }
}